import { cn } from '@mint-lib/tw-utils';

import { Avatar, AvatarImage } from '../../lib/avatar.jsx';
import { AvatarAiPaddings, AvatarAiRoles } from './constants.js';

type AvatarSize = 'xsmall' | 'small' | 'medium' | 'large' | 'mega';
type AvatarRole = keyof typeof AvatarAiRoles;

export type AvatarAiProps = {
  size?: AvatarSize;
  role: AvatarRole;
  hasPointer?: boolean;
  className?: string;
};
const AvatarAi = ({ size, role, hasPointer, className }: AvatarAiProps) => {
  return (
    <Avatar
      data-testid="avatar-ai"
      size={size}
      className={cn(
        'pointer-events-none border-none group-hover/avatar:opacity-100 before:bg-transparent hover:bg-transparent hover:before:bg-transparent',
        hasPointer ? 'cursor-pointer' : 'cursor-auto',
        className,
      )}
    >
      <AvatarImage
        src={AvatarAiRoles[role]}
        style={{
          padding: AvatarAiPaddings[size ?? 'large'],
        }}
        className="h-full w-full rounded-full bg-gradient-to-t from-ai-lightCyan to-ai-lightGreen group-hover/avatar:opacity-100 before:bg-transparent hover:bg-transparent hover:before:bg-transparent"
      />
    </Avatar>
  );
};
export default AvatarAi;
